<template>
  <div id="app">
    <loading v-show="LOADING"></loading>
    <router-view/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Loading from '@/views/axios-loading.vue'
export default {
  name: 'app',
  components: {
    Loading
  },
  computed: {
    ...mapState([
      'LOADING'
    ])
  }
}
</script>

<style>
</style>
